<template>
  <div class="flowmap-box small" :style="{ width }">
    <w-flow-map-flow-field :perf-records="rscPerfData" perf-key="SYSSTAT/DB_CLIENT_SENDSIZE" :arrow-settings="arrowSettings" label="송신량" >
    </w-flow-map-flow-field>
    <slot name="arrowContent"></slot>
    <div class="flowmap-header">
      {{title}}
    </div>
    <div class="flowmap-content">
      <slot name="countBoxContent"></slot>
    </div>
  </div>
</template>

<script>
import WFlowMapFlowField from './FlowMapFlowField';

export default {
  name: 'WFlowMapCountBoxContainer',
  components: {
    WFlowMapFlowField,
  },
  props: {
    rscPerfData: {
      type: Object,
    },
    title: {
      type: String,
    },
    width: {
      type: String,
    },
  },
  data() {
    return {
      hasEvent: false,
      arrowSettings: {
        top: '180px',
        arrowDirection: 'arrow-left',
        arrowSize: 'small',
      },
    };
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/database-flow-map/components/FlowMapCountBoxContainer.vue